var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllpingsIncLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22656 24.8782L12.1719 14.9329L16.4172 19.2079L33.4578 2.16724",
    stroke: "#39BF8F",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3633 2.16724H33.4586V9.26255",
    stroke: "#39BF8F",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7461 22.0425V33.3979",
    stroke: "#010412",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2656 24.8779V33.3982",
    stroke: "#010412",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7871 13.5227V33.3985",
    stroke: "#010412",
    strokeWidth: 2.83516,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllpingsIncLight);
export default __webpack_public_path__ + "static/media/allpings_inc_light.311d8bb70aecb072994d5499b71b0c52.svg";
export { ForwardRef as ReactComponent };